var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Entry from 'root/src/client/web/giveaway/components/Entry';
import ButtonNew from 'root/src/client/web/base/ButtonNew';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { useActionEntry } from 'root/src/client/web/giveaway/features/GiveawayStats/hooks/useActionEntry';
import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { colorsNew } from 'root/src/client/web/commonStyles';
import { typographyVariants } from 'root/src/client/web/typography/Typography';
import { useIsAuthenticated } from 'root/src/client/v2/auth/hooks/useIsAuthenticated';
import { useCreatorActiveGiveaway } from 'root/src/client/web/giveaway/hooks/useCreatorGiveaways';
import toast from 'react-hot-toast';
const EntryDisabledTooltipContent = () => {
    const isAuthenticated = useIsAuthenticated();
    const giveaway = useCreatorActiveGiveaway();
    if (!isAuthenticated) {
        return (<BaseTooltipContent>
				Please log in in order to submit an entry.
			</BaseTooltipContent>);
    }
    const canEnter = giveaway && (giveaway.isSteamEntered || giveaway.isSMSEntered);
    if (!canEnter) {
        return (<BaseTooltipContent className="bg-white text-black">
				Please connect your Steam account <br />in order to enter the giveaway.
			</BaseTooltipContent>);
    }
    if (!(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isEntered)) {
        return (<BaseTooltipContent className="bg-white text-black">
				Please enter to the giveaway in order to submit an entry.
			</BaseTooltipContent>);
    }
    return null;
};
export const ActionEntry = (props) => {
    var _a, _b;
    const { entry, disabled } = props;
    const { onEntrySubmit, isLoading, giveaway } = useActionEntry(entry);
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (disabled) {
            if (!(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isEntered)) {
                const selector = document.querySelector('.enter-giveaway');
                if (selector) {
                    selector.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                    selector.focus();
                }
                toast.error('Please enter the giveaway in order to submit an entry.');
                return;
            }
            return;
        }
        yield onEntrySubmit();
    });
    if (!entry.isVisible) {
        return null;
    }
    return (<Entry.Root className="border flex flex-col sm:flex-row">
			<Entry.Label className="gap-4">
				<Entry.LabelIcon src={((_a = entry.icon) === null || _a === void 0 ? void 0 : _a.src) || ''} alt={entry.label}/>
				<Entry.LabelText>{entry.label}</Entry.LabelText>
			</Entry.Label>
			<Entry.Trigger>
				{entry.isDone ? <Entry.SuccessIcon /> : (<>
						<BaseTooltip tooltip={disabled && <EntryDisabledTooltipContent />}>
							<ButtonNew style={{ background: colorsNew.white, borderRadius: '100px', height: 40, width: 140 }} onClick={handleClick} typography={typographyVariants.providerSignIn}>
								<Entry.ButtonContent>
									<Entry.ButtonIcon src={((_b = entry.icon) === null || _b === void 0 ? void 0 : _b.src) || ''} alt={entry.label}/>
									<Entry.ButtonAction>{entry.actionName}</Entry.ButtonAction>
								</Entry.ButtonContent>
							</ButtonNew>
						</BaseTooltip>
						<Entry.Score>{isLoading ? <LoadingCircles width={20} height={20}/> : `+${entry.score}`}</Entry.Score>
					</>)}
			</Entry.Trigger>
		</Entry.Root>);
};
